class SectionBackgroundText implements ng.IComponentController {
    background: 'blue';
    ltTitle: string;
    description: string;
}

angular.module('animatronApp.sectionBackgroundText', []).component('sectionBackgroundText', {
    bindings: {
        ltTitle: '<?',
        background: '<?',
        description: '<?',
    },
    controller: SectionBackgroundText,
    templateUrl: require('landing-template/components/sections/section-background-text.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionBackgroundText.ts